import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFemale, faRestroom, faMale, faTrophy, faTag, faSitemap, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../firebase';

import data from '../../constants/tournament.json';
import TournamentLoader from '../loaders/TournamentLoader';
import ModalForm from '../useful/ModalForm';
import ModalInfo from '../useful/ModalInfo';
import TournamentForm from './TournamentForm';

const TournamentData = (props) => {

    const { _format, _type } = data;
    const { loading, tournament } = props;
    const [modal, setModal] = useState({ show: false, title: '', message: '' });
    const [formShow, setFormShow] = useState(false);

    if (loading) {
        return (
            <div className="col p-2 m-0">
                <TournamentLoader />
            </div>
        )
    }

    const showTournamentForm = () => {
        setFormShow(true);
    }

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const genderIcon = (tournament.gender === "M") ? faMale : (tournament.gender === "F") ? faFemale : faRestroom;
    const genderText = (tournament.gender === "M") ? "Masculino" : (tournament.gender === "F") ? "Femenino" : "Mixto";
    let subType = "";
    if (tournament && tournament.subType) {
        subType = " (" + tournament.subType + ")";
    }

    return (
        <>
            <div className="bg-hover-btn col p-2 ">
                <div className="d-flex flex-row align-items-center text-dark font-weight-bold mr-0 ml-0 2">
                    <FontAwesomeIcon className="mr-2 text-third" size="lg" icon={faTrophy} />
                    <span className="flex-fill">{tournament && tournament.title}</span>
                    <button onClick={showTournamentForm} className="btn btn-second btn-sm ml-2" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                        <span className="d-none d-md-inline">Editar</span>
                        <FontAwesomeIcon className="ml-0 ml-md-2 " icon={faPencilAlt} />
                    </button>
                </div>
                <div className="mt-2" >

                    <ul className="list-group list-group-horizontal mb-0" style={{ fontSize: '0.9em', listStyleType: 'none' }}>
                        <li className="ml-1 text-center">
                            <FontAwesomeIcon className="mr-1 text-third" icon={faTag} />
                            <span className="text-nowrap">{tournament && (_format[tournament.format] || "-")}</span>
                        </li>
                        <li className="ml-2 text-center">
                            <FontAwesomeIcon className="mr-1 text-third" icon={faSitemap} />
                            <span className="text-wrap">{tournament && (_type[tournament.type] || "-") + subType}</span>
                        </li>
                        <li className="ml-2 text-center">
                            <FontAwesomeIcon className="mr-1 text-third" icon={genderIcon} />
                            <span className="text-nowrap">{genderText}</span>
                        </li>
                    </ul>

                </div>
            </div >

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

            <ModalForm
                show={formShow}
                onClose={() => setFormShow(false)}
            >
                <TournamentForm tournament={tournament}
                    showModal={showModal} isOpen={formShow}
                    onClose={() => setFormShow(false)} />
            </ModalForm>
        </>
    )

}

// export default withFirebase(React.memo(TournamentListItem));
export default withFirebase(TournamentData);
